import styled from "styled-components";

export const ContainerSection = styled.section`
  ul {
    display: flex;
    flex-wrap: wrap;
  }
  
`;
